import Phaser from 'phaser'

export default class CameraController {
  constructor (scene, player) {
    this.scene = scene
    this.player = player
    this.cam = this.scene.cameras.main

    this.x = -70
    this.y = 150// 200// -100
    this.offsetX = 500
    this.offsetY = 200
    this.targetX = this.x
    this.targetY = this.y
    this.zoom = 1// 0.8
    this.zoomTarget = this.zoom

    this.dragOriginX = 0
    this.dragOriginY = 0
    this.isDragging = false
    this.dragTargetX = 0
    this.dragTargetY = 0
    this.speedX = 0
    this.speedY = 0

    // some debug lines:
    this.btmLine = this.scene.add.image(500, -210, 'white')
    this.btmLine.setTint(0xffffff)
    this.btmLine.setDepth(1000)
    this.btmLine.setDisplaySize(2000, 2)

    this.topLine = this.scene.add.image(500, 510, 'white')
    this.topLine.setTint(0xffffff)
    this.topLine.setDepth(1000)
    this.topLine.setDisplaySize(2000, 2)

    this.btmLine.setVisible(false)
    this.topLine.setVisible(false)

    // this.btmLine.setScrollFactor(0, 0)
    // temp = this.scene.add.image(500, 650, 'white').setTint(0)
    // temp.setDisplaySize(2000, 10)
    // temp.setScrollFactor(0, 0)

    // temp = this.scene.add.image(1280 * (2 / 3), 400, 'white').setTint(0)
    // temp.setDisplaySize(10, 1600)
    // temp.setScrollFactor(0, 0)
    // temp = this.scene.add.image(500, 720 * (4 / 6), 'white').setTint(0)
    // temp.setDisplaySize(2000, 10)
    // temp.setScrollFactor(0, 0)
    // temp = this.scene.add.image(500, 720 * (2 / 6), 'white').setTint(0)
    // temp.setDisplaySize(2000, 10)
    // temp.setScrollFactor(0, 0)
    // temp = this.scene.add.image(500, 720 * (5 / 6), 'white').setTint(0x999999)
    // temp.setDisplaySize(2000, 10)
    // temp.setScrollFactor(0, 0)
  }

  snapToPlayer () {
    this.targetX = this.player.image.x + this.offsetX
    this.targetY = this.player.image.y + this.offsetY
    this.x = this.targetX
    this.y = this.targetY

    this.cam.setScroll(this.x - this.cam.width / 2, this.y - this.cam.height / 2)
  }

  updateEditorCamera (time, delta) {
    if (this.scene.input.activePointer.middleButtonDown()) {
      if (!this.isDragging) {
        this.dragOriginX = this.scene.input.activePointer.x
        this.dragOriginY = this.scene.input.activePointer.y
        this.isDragging = true
      } else {
        // drag..
        this.speedX = -1 * (this.scene.input.activePointer.x - this.dragOriginX) / this.zoom
        this.speedY = -1 * (this.scene.input.activePointer.y - this.dragOriginY) / this.zoom
        this.dragOriginX = this.scene.input.activePointer.x
        this.dragOriginY = this.scene.input.activePointer.y
      }
    } else {
      this.isDragging = false
      this.speedX = 0.95 * this.speedX
      this.speedY = 0.95 * this.speedY
    }

    this.x += this.speedX
    this.y += this.speedY

    if (this.scene.input.activePointer.deltaY < -1) {
      this.zoom += delta * 0.00125
    } else if (this.scene.input.activePointer.deltaY > 1) {
      this.zoom -= delta * 0.00125
    }
    this.zoom = Phaser.Math.Clamp(this.zoom, 0.25, 1.25)
    this.scene.input.activePointer.deltaY = 0
  }

  updateGameplayCamera (time, delta) {
    if (this.scene.spawner.guide) {
      this.currPlatformY = this.scene.spawner.guide.getNearestPoint(this.player.image.x, this.currPlatformY)
    } else {
      this.currPlatformY = 400
    }

    var bottom = Math.max(this.currPlatformY, this.player.image.y + 20)
    bottom = Math.min(bottom, this.player.gameoverThreshold - 500)
    this.targetY = bottom - 250

    this.zoomTarget = 1
    if (this.player.image.x > 300 && this.player.image.x < this.scene.spawner.finishX - 1300) {
      this.zoomTarget = 0.55
    }

    // x-position:
    var max = 70
    var min = 70
    this.targetX = Math.min(this.player.image.x, this.scene.spawner.finishX - 420)
    if (this.targetX > this.x + max) {
      this.x = this.targetX - max
    } else if (this.targetX < this.x + min) {
      this.x = this.targetX - min
    }

    var zoomSpeed = 0.0005
    this.zoom += ((this.zoomTarget - this.zoom) * (delta * zoomSpeed))

    console.log(this.targetY)

    // y-position:
    this.speedY = 0.001// this.targetY > this.y ? (this.targetY - this.y) * 0.0001 : 0.001
    this.y += ((this.targetY - this.y) * (delta * this.speedY))
  }

  update (time, delta) {
    if (this.scene.levelEditor.enabled) {
      this.updateEditorCamera(time, delta)
    } else if (!this.teleported) {
      this.updateGameplayCamera(time, delta)
    }

    this.cam.setScroll(this.x - this.cam.width / 2 + this.offsetX, this.y - this.cam.height / 2 + (this.scene.landscape ? 0 : 280))
    this.cam.setZoom(this.zoom * (this.scene.landscape ? 1 : 0.5625))
  }

  onTeleport () {
    this.teleported = true
    this.x = this.player.cake.image.x - 490
    this.y = this.player.cake.image.y - 85
  }
}
